"use client";

import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as React from "react";

import { Colors } from "@/constants/colors";
import { cn } from "@/lib/utils";

// Extract color keys from the Colors object
type ColorKey = keyof typeof Colors.bg;

interface ProgressProps extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> {
  activeColor?: ColorKey;
  backgroundColor?: ColorKey;
}

const Progress = React.forwardRef<React.ElementRef<typeof ProgressPrimitive.Root>, ProgressProps>(
  ({ className, value, activeColor, backgroundColor, ...props }, ref) => {
    // Default background color is primary/20, default active color is brandTangerine
    const bgColorClass = backgroundColor ? Colors.bg[backgroundColor] : Colors.bg.backgroundOffwhite;
    const activeColorClass = activeColor ? Colors.bg[activeColor] : Colors.bg.brandTangerine;

    return (
      <ProgressPrimitive.Root
        ref={ref}
        className={cn("relative h-[6px] w-full overflow-hidden rounded-full", bgColorClass, className)}
        {...props}
      >
        <ProgressPrimitive.Indicator
          className={cn("h-full w-full flex-1 transition-all rounded-full", activeColorClass)}
          style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        />
      </ProgressPrimitive.Root>
    );
  },
);
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
